module.exports = __webpack_public_path__ + "img/pergola-over-door.74ba183a.webp";